import React from "react";
import BaseModel from '../BaseModel';
import {
    ApplicationCreateBrick,
    CartAddArticleBrick,
    CartSetUserData,
    ContextSetData,
    EmailSendBrick,
    FormHandleBrick,
    FormShowBrick,
    RedirectBrick,
    UserUpdateBrick,
} from '.';

/** Class representing a workflow brick. */
class Brick extends BaseModel {
    static make(props) {
        const map = {
            'application.create': ApplicationCreateBrick,
            'cart.add.article': CartAddArticleBrick,
            'cart.set.user.data': CartSetUserData,
            'context.set.data': ContextSetData,
            'email.send': EmailSendBrick,
            'form.handle': FormHandleBrick,
            'form.show': FormShowBrick,
            'redirect': RedirectBrick,
            'user.update': UserUpdateBrick,
        };

        const { type } = props;
        if (!type || !map[type])
            throw new Error(`Brick type ${type} not found!`);

        return new map[type](props);
    }

    static getBrickTypes() {
        return [
            'application.create',
            'cart.add.article',
            'cart.set.user.data',
            'context.set.data',
            'email.send',
            'form.handle',
            'form.show',
            'redirect',
            'user.update',
        ];
    }

    /**
     * Run this brick
     */
    run() {
        return <div className={ this.type } />;
    }

    /**
     * Get this brick optioçns form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     */
    getOptionsForm(props) {
        return null;
    }

    /**
     * Must thie brick run server side ?
     *
     * @return {Boolean}
     **/
    isServerSide() {
        return !!this.server_side;
    }

    /**
     * Get this brick inputs
     *
     * @return {String[]}
     **/
    getInputs() {
        return [];
    }

    /**
     * Get this brick inputs mapping
     *
     * @return {Object}
     **/
    getInputsMapping() {
        return this.inputs_mapping;
    }

    /**
     * Get one of this brick inputs mapping
     *
     * @return {String}
     **/
    getInputMapping(input) {
        return this.inputs_mapping[input] ?? null;
    }

    /**
     * Get this brick outputs
     *
     * @return {String[]}
     **/
    getOutputs() {
        return [];
    }

    /**
     * Get one of this brick option value
     *
     * @param {String} option
     * @param {Any} _default
     *
     * @return {Any}
     */
    getOption(option, _default) {
        return this.options[option] ?? _default;
    }
}

export default Brick;
